import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { candidateActions } from "../../actions/candidateActions";
import api from "../../api/candidate.resource";
import { defaultToastOptions, EMPLOYEE_TYPES, ROLES } from "../../constants/constants";
import useValidation from "../../util/useValidation";
import {
  embeddedSpacesPattern,
  alphaNumericWithSpacePattern,
  mobileNumberPattern,
  emailIDPattern
} from "../../constants/constants";

const ManageUsers = ({
  userRoles,
  getUserRoles,
  userData = {},
  roleId,
  isEditUser = false,
  onClose
}) => {
  const initialUserDetails = {
    userName: userData.userName || "",
    roleId: userData.roleId || roleId || "",
    firstName: userData.firstName || "",
    lastName: userData.lastName || "",
    // Placing permanent type as default value. Refer EMPLOYEE_TYPES for the id.
    cDKEmployeeType: userData.cDKEmployeeType || "1",
    contactNumber: userData.contactNumber || "",
    status: userData.status || 0,
    emailId: userData.emailId || "",
    ...(isEditUser && { id: userData.id }),
    ...(!isEditUser && { inviteUser: 1 })
  };
  const { handleOnBlurValidation, errors } = useValidation();
  const [isValid, setIsValid] = useState(false);
  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const userForm = useRef(null);

  useEffect(() => {
    getUserRoles();
  }, []);

  useEffect(() => {
    setIsValid(isValidUserData());
  });

  const user = JSON.parse(window.sessionStorage.getItem("user"));

  const handleOnChangeInput = e => {
    const { name, value, type, checked } = e.target;
    if (embeddedSpacesPattern.test(value)) {
      const updatedValue =
        type === "checkbox" ? Number(checked) : value.trimStart();
      setUserDetails(prevState => ({ ...prevState, [name]: updatedValue }));
    }
  };

  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnSubmitCreateUser = async () => {
    try {
      toast.configure();
      const res = await api.createNewUser({
        ...userDetails,
        status: userDetails.inviteUser,
        userName: userDetails.emailId,
        createdBy: user.id
      });
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Created User`, defaultToastOptions);
          onClose();
        }
      }
    } catch (e) {
      toast.error(`Error while Creating User`, defaultToastOptions);
    }
  };
  const handleOnSubmitUpdateUser = async () => {
    try {
      toast.configure();
      const res = await api.updateUserDetails({
        ...userDetails,
        userName: userDetails.emailId,
        updatedBy: user.id
      });
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(
            `Successfully Updated UserDetails`,
            defaultToastOptions
          );
        }
        onClose();
      }
    } catch (e) {
      toast.error(`Error while Updating User`, defaultToastOptions);
    }
  };

  const isValidUserData = () =>
    userForm.current && userForm.current.checkValidity();

  const rolesToDisplay =
    roleId === ROLES.CANDIDATE
      ? userRoles
      : userRoles.filter(role => role.id !== ROLES.CANDIDATE);

  return (
    <Modal
      show
      onHide={onClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      //dialogClassName="modal-90w"
      //aria-labelledby="example-custom-modal-styling-title"
    >
      <Modal.Header closeButton>
        <Modal.Title>{!isEditUser ? "ADD USER" : "MODIFY USER"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form ref={userForm}>
          <Form.Group as={Row} controlId="userFirstName">
            <Form.Label column sm={3} className="text-right">
              First Name*
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                size="sm"
                type="text"
                name="firstName"
                required
                placeholder="First Name"
                value={userDetails.firstName}
                pattern={alphaNumericWithSpacePattern}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                isInvalid={errors.firstName}
              />

              {errors.firstName && (
                <Form.Control.Feedback type="invalid">
                  {errors.firstName.type === "required" &&
                    "First Name is required"}
                  {errors.firstName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="userLastName">
            <Form.Label column sm={3} className="text-right">
              Last Name*
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                size="sm"
                type="text"
                name="lastName"
                required
                placeholder="Last Name"
                value={userDetails.lastName}
                pattern={alphaNumericWithSpacePattern}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                isInvalid={errors.lastName}
              />
              {errors.lastName && (
                <Form.Control.Feedback type="invalid">
                  {errors.lastName.type === "required" &&
                    "Last Name is required"}
                  {errors.lastName.type === "pattern" &&
                    "Must contain only alphabets and space"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          {userDetails.roleId !== ROLES.CANDIDATE && (
            <Form.Group as={Row} controlId="userRole">
              <Form.Label column sm={3} className="text-right">
                Role*
              </Form.Label>
              <Col sm={7}>
                <Form.Control
                  size="sm"
                  as="select"
                  className="my-1 mr-sm-2"
                  custom
                  required
                  name="roleId"
                  value={userDetails.roleId}
                  // disabled={userDetails.roleId === ROLES.CANDIDATE}
                  onChange={handleOnChangeInput}
                  onBlur={handleOnBlurInput}
                  isInvalid={errors.roleId}
                >
                  <option value="">Choose...</option>
                  {rolesToDisplay &&
                    rolesToDisplay.map(role => (
                      <option key={role.id} value={role.id}>
                        {role.role}
                      </option>
                    ))}
                </Form.Control>
                {errors.roleId && (
                  <Form.Control.Feedback type="invalid">
                    {errors.roleId.type === "required" && "Role is required"}
                  </Form.Control.Feedback>
                )}
              </Col>
            </Form.Group>
          )}

          <Form.Group as={Row} controlId="userMobile">
            <Form.Label column sm={3} className="text-right">
              Mobile Number*
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                size="sm"
                type="text"
                name="contactNumber"
                required
                placeholder="Mobile"
                value={userDetails.contactNumber}
                pattern={mobileNumberPattern}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                isInvalid={errors.contactNumber}
              />
              {errors.contactNumber && (
                <Form.Control.Feedback type="invalid">
                  {errors.contactNumber.type === "required" &&
                    "Mobile Number is required"}
                  {errors.contactNumber.type === "pattern" &&
                    "Please enter a valid Mobile Number"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>
          <Form.Group as={Row} controlId="userEmailId">
            <Form.Label column sm={3} className="text-right">
              Email*
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                size="sm"
                type="text"
                name="emailId"
                required
                placeholder="Email"
                value={userDetails.emailId}
                pattern={emailIDPattern}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                isInvalid={errors.emailId}
              />
              {errors.emailId && (
                <Form.Control.Feedback type="invalid">
                  {errors.emailId.type === "required" && "Email is required"}
                  {errors.emailId.type === "pattern" &&
                    "Please enter a valid Email ID"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          <Form.Group as={Row} controlId="cDKEmployeeType">
            <Form.Label column sm={3} className="text-right">
              Employee Type*
            </Form.Label>
            <Col sm={7}>
              <Form.Control
                size="sm"
                as="select"
                name="cDKEmployeeType"
                required
                value={userDetails.cDKEmployeeType}
                onChange={handleOnChangeInput}
                onBlur={handleOnBlurInput}
                isInvalid={errors.cDKEmployeeType}
              >
                {EMPLOYEE_TYPES.length &&
                  EMPLOYEE_TYPES.map(employeeType => (
                    <option value={employeeType.id}>{employeeType.name}</option>
                  ))}
              </Form.Control>
              {errors.cDKEmployeeType && (
                <Form.Control.Feedback type="invalid">
                  {errors.cDKEmployeeType.type === "required" && "Employee Type is required"}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          {!isEditUser && (
            <Form.Group as={Row} className="w-100 ml-0 text-right">
              <Col sm={10}>
                <Form.Check
                  label="Invite User"
                  name="inviteUser"
                  value={userDetails.inviteUser}
                  checked={userDetails.inviteUser}
                  onChange={handleOnChangeInput}
                />
              </Col>
            </Form.Group>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        {!isEditUser ? (
          <Button
            variant="primary"
            onClick={handleOnSubmitCreateUser}
            disabled={!isValid}
          >
            ADD USER
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={handleOnSubmitUpdateUser}
            disabled={!isValid}
          >
            UPDATE USER
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
const mapStateToProps = ({ candidateDetails }) => ({
  userRoles: candidateDetails.userRoles || []
});
const mapDispatchToProps = {
  getUserRoles: candidateActions.getUserRoles
};
export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
